import { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import img_1 from '../assets/images/tra/1.webp';
import img_2 from '../assets/images/tra/2.webp';
import img_3 from '../assets/images/tra/3.webp';
import img_4 from '../assets/images/tra/4.webp';
import img_5 from '../assets/images/tra/5.webp';
import img_6 from '../assets/images/tra/6.webp';
// import img_7 from '../assets/images/tra/7.webp';
import img_8 from '../assets/images/tra/8.webp';
import img_9 from '../assets/images/tra/9.webp';
import img_sun from '../assets/images/tra/sun.webp';
import img_tree from '../assets/images/tra/tree.webp';
import img_c1 from '../assets/images/tra/c1.webp';
import img_c2 from '../assets/images/tra/c2.webp';
import img_c3 from '../assets/images/tra/c3.webp';
import video_1 from '../assets/videos/1.mp4';
import video_jx from '../assets/videos/jx.mp4';
import video_py from '../assets/videos/py.mp4';
import video_tw from '../assets/videos/tw.mp4';
import video_7 from '../assets/videos/7.mp4';
import '../styles/common.css';

export default function Traceability() {
  const navigate = useNavigate();
  const [currentText, setCurrentText] = useState('');
  const [showDetail, setShowDetail] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const [img4Visible, setImg4Visible] = useState(false); // 新增：控制图片动画的状态
  const thirdSectionRef = useRef<HTMLDivElement>(null); // 新增：父容器 ref
  const fifthSectionRef = useRef<HTMLDivElement>(null);
  const sixthSectionRef = useRef<HTMLDivElement>(null);
  const [activeCard, setActiveCard] = useState(1);
  const [current4600, setCurrent4600] = useState(0); // 4600的当前显示值
  const [current2190, setCurrent2190] = useState(0); // 2190的当前显示值
  const [isFifthAnimated, setIsFifthAnimated] = useState(false); // 第五部分动画状态
  const [isSixthAnimated, setIsSixthAnimated] = useState(false); // 第六部分动画状态
  const targetText = '什么是“天籁瓷鉴”？ What is “Tianlai.China ?”';

  useEffect(() => {
    let charIndex = 0;
    let timer: NodeJS.Timeout;
    let thirdObserver: IntersectionObserver | null = null; // 第三部分观察者（原 observer）
    let fifthObserver: IntersectionObserver | null = null; // 第五部分独立观察者
    let sixthObserver: IntersectionObserver | null = null; // 第六部分独立观察者

    const startTyping = () => {
      charIndex = 0;
      setCurrentText('');
      timer = setInterval(() => {
        if (charIndex <= targetText.length) {
          setCurrentText(targetText.substring(0, charIndex));
          charIndex++;
        } else {
          clearInterval(timer);
          // 完成后等待3秒（而非500ms）再重新开始，减少闪烁
          setTimeout(startTyping, 3000);
        }
      }, 80);
    };

    startTyping(); // 初始启动
    // 初始化 Intersection Observer（移至顶层）
    if (thirdSectionRef.current) {
      thirdObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setImg4Visible(true);
            thirdObserver?.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });
      thirdObserver.observe(thirdSectionRef.current);
    }
    // 第五部分观察者（控制 img_sun/img_tree 动画）
    if (fifthSectionRef.current) {
      fifthObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setIsFifthAnimated(true); // 独立控制第五部分状态
            fifthObserver?.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 }); // 调整为 30% 可见触发（更明显）
      fifthObserver.observe(fifthSectionRef.current);
    }

    // 第六部分观察者（控制 img_c1/img_c2/img_c3 动画）
    if (sixthSectionRef.current) {
      sixthObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setIsSixthAnimated(true);
            // 启动4600递增动画（50ms/次，每次+100）
            const timer4600 = setInterval(() => {
              setCurrent4600(prev => Math.min(prev + 100, 4600));
            }, 50);
            // 启动2190递增动画（50ms/次，每次+50）
            const timer2190 = setInterval(() => {
              setCurrent2190(prev => Math.min(prev + 50, 2190));
            }, 50);
            // 到达目标值后清理定时器
            const clearTimers = () => {
              if (current4600 >= 4600 && current2190 >= 2190) {
                clearInterval(timer4600);
                clearInterval(timer2190);
              }
            };
            const checkInterval = setInterval(clearTimers, 100);
            sixthObserver?.unobserve(entry.target);
            // 清理函数中移除所有定时器
            return () => {
              clearInterval(timer4600);
              clearInterval(timer2190);
              clearInterval(checkInterval);
            };
          }
        });
      }, { threshold: 0.3 });
      sixthObserver.observe(sixthSectionRef.current);
    }
    // 顶层清理函数（无论条件是否成立都会执行）
    return () => {
      clearInterval(timer); // 清理打字机定时器
      clearTimeout(timer); // 清理重新启动的定时器
      thirdObserver?.disconnect();
      fifthObserver?.disconnect();
      sixthObserver?.disconnect();
    };
  }, []);
  const location = useLocation();

  useEffect(() => {
    if (location.hash === '#molin-section') {
      const element = document.getElementById('molin-section');
      element?.scrollIntoView({ behavior: 'auto' });
    }
  }, [location]);
  return (
    <div className="relative" style={{ overflowX: 'hidden' }} >
      {/* 第一部分 */}
      <div className="relative">
        <img src={img_1} alt="Hero background" className="w-full h-auto" />
        <div className="top-[9.5vw] w-auto absolute left-[44%]">
          <div className="flex flex-row items-left gap-[5vw]">
            <span className="text-[4.5vw] font-['WYXHGYS'] vertical-text">历代名瓷图谱</span>
            <span className="text-[1.4vw] font-['Huiwen'] rotate-90" style={{
              marginTop: '0.5vw',
              maxWidth: '24vw',  /* 限制最大宽度，让文字自动换行 */
              wordBreak: 'break-all'  /* 允许单词内换行 */
            }}>
              Illustrated Catalog of Eminent Ceramics Through Chinese Dynasties
            </span>
          </div>
        </div>
        <div className="left-[5%]  bottom-[4%] absolute w-[85%]">
          <div className="flex flex-col items-left">
            <span className="text-[#7292BB] text-[2.3vw] font-['MLGKT']">天籁瓷鉴：项元汴《历代名瓷图谱》的数字考古</span>
            <span className="text-[#7292BB] text-[1.2vw] font-['Huiwen']">Tianlai.China: Digital Archaeology of Xiang Yuanbian's The Illustrated Manual of Famous Porcelains Through the Ages</span>
            <span className="text-[#7696C0] text-[0.9vw]" style={{ marginTop: '0.8vw', letterSpacing: '0.05vw' }}>本网站以明代鉴藏大家项元汴编撰的《历代名瓷图谱》为核心，通过数字化手段对典籍中83件珍稀瓷器进行多维度可视化解析。</span>
            <span className="text-[#7696C0] text-[0.9vw]" style={{ letterSpacing: '0.05vw' }}>在这里，每件瓷器既是独立的美学符号，又是串联起明代文人鉴藏体系的时空坐标，邀您共同探索物质文化与艺术审美的深层对话。</span>
            <span className="text-[#7696C0] text-[0.9vw] text-justify" style={{ letterSpacing: '0.05vw' }}>With the Atlas of Famous Porcelains of All Ages compiled by Xiang Yuanbian, a great connoisseur of the Ming Dynasty, as the core, this website carries out a multi-dimensional visual analysis of 83 rare porcelains in the canonical works through digital means. Here, each piece of porcelain is not only an independent aesthetic symbol, but also a space-time coordinate linking up the Ming literati's connoisseurship system, inviting you to explore the deep dialogue between material culture and artistic aesthetics.</span>
          </div>
        </div>
      </div>
      {/* 第二部分 */}
      <div className="relative">
        <img src={img_2} alt="Hero background" className="w-full h-auto" />
        <div
          className={`absolute w-auto ${showDetail ? 'top-[4vw]' : 'top-[12vw]'} left-[50%] transform -translate-x-1/2 z-[9999] transition-all duration-500`} // 新增过渡动画
        >
          <div className="relative inline-flex items-end gap-2">
            <span className={`text-[#fff] ${showDetail ? 'text-[2.5vw]' : 'text-[3.6vw]'} font-['TsangerTQXKW'] transition-all duration-500`}>天籁瓷鉴</span>
            <span className={`text-[#fff] ${showDetail ? 'text-[1.2vw] -translate-y-[0.4vw]' : 'text-[2vw] -translate-y-[0.4vw]'} transform translate-x-[0.4vw] transition-all duration-500`}>Tianlai.China</span>
          </div>
        </div>
        {/* 默认显示内容（未点击时） */}
        {!showDetail && (
          <>
            <div className="typing-text-box">
              {currentText}
            </div>
            <div
              className="absolute w-auto bottom-[16vw] left-[50%] transform -translate-x-1/2 z-[9999] transparent-rounded-button flex flex-col items-center text-center"
              onClick={() => {
                setShowDetail(true); // 立即触发文字动画
                // 延迟1秒（与动画时长一致）后显示详细内容
                setTimeout(() => setShowContent(true), 500);
              }}
            >
              <span>了解更多</span>
              <span>Learn More</span>
            </div>
          </>
        )}
        {/* 点击了解更多后显示的内容 */}
        {/* 点击了解更多后显示的内容（延迟1秒） */}
        {showContent && (
          <div className={`absolute w-[70%] top-[11vw] left-[50%] transform -translate-x-1/2 text-center ${showContent ? 'opacity-100' : 'opacity-0'} transition-opacity duration-500`}>
            <div className="flex flex-col items-center text-center leading-[1.6vw]">
              <span className="text-[#fff] text-[1.5vw]">什么是“天籁瓷鉴”？ What is “Tianlai.China ?”</span>
              <span className="text-[#fff] text-[0.9vw] mt-[4vw]">“天籁瓷鉴”是一项以明代鉴藏大家项元汴编撰的《历代名瓷图谱》为核心数字人文项目，是全球首个系统性研究该图谱的数字工程。我们构建了“溯源-鉴析-探微-品韵”四大维度，对典籍中83件珍稀瓷器进行多维可视化解析，包括家族收藏网络动态重构、工艺特征多视图协同分析、独特性熵权量化模型和4.2万字评注情感解码，构建主客观对话，让独特性量化数据与项元汴主观偏好在关联网络中碰撞，验证“以器载道”的实践逻辑。首次系统性地将传统鉴藏体系转化为可视化、可交互、可量化的数据语言。“天籁瓷鉴”首次对图谱进行系统性数字解读，填补明代民间鉴藏可视化研究的空白；将文物鉴定的经验性知识转化为可验证的量化模型，为艺术史研究提供跨学科方法论；从艺术史到数据科学，从美学哲学到量化模型，我们试图证明：文明的精魂终将在新介质中重生。
              </span>
              <span className="text-[#fff] text-[0.9vw] mt-[2vw]">
                "Tianlai.China" is a pioneering digital humanities project centered on Illustrated Catalog of Famous Porcelains Through the Ages, compiled by Ming Dynasty renowned connoisseur Xiang Yuanbian. As the world's first systematic digital study of this historical canon, the project structures exploration through four dimensions: 1.Traceability – Dynamically reconstructing familial collection networks 2.Appreciation – Multi-view coordinated analysis of craft characteristics 3.Exploration – Entropy-weighted quantitative modeling of uniqueness 4.Rhyme Tasting – Sentiment decoding of 42K expert annotations. Through multi-dimensional visual analysis of 83 rare porcelains, we forge dialogue between objectivity and subjectivity: quantifiable uniqueness metrics collide with Xiang's aesthetic preferences in interactive networks, empirically validating his philosophy of "embodying Dao through objects". This represents the first systematic transformation of traditional connoisseurship into visualized, interactive, and quantified data language.
              </span>
              <span className="text-[#fff] text-[0.9vw] mt-[2vw]">
                "Tianlai.China" pioneers the first systematic digital interpretation of this historical canon, addressing a critical gap in visualizing Ming Dynasty private art connoisseurship. It transforms experiential knowledge of artifact authentication into verifiable quantitative models, establishing an interdisciplinary methodology for art historical research. From art history to data science, aesthetic philosophy to computational metrics, we demonstrate: the essence of civilization finds enduring vitality through new mediums.
              </span>
            </div>
          </div>
        )}
      </div>
      {/* 第三部分 */}
      <div className="relative" ref={thirdSectionRef}>
        <img src={img_3} alt="Hero background" className="w-full h-auto" />
        <div className="top-[7vw] absolute left-[50%] transform -translate-x-1/2 w-[37%] z-[9999]">
          <div className="flex flex-col items-center text-center">
            <span className="text-[#000000] text-[1.8vw]">关于“天籁瓷鉴”</span>
            <span className="text-[#000000] text-[1.6vw]">Introduction of Tianlai.China</span>
            <span className="text-[#000000] text-[0.8vw] text-justify mt-[1.8vw] leading-[1.5vw]">
              本网站以明代鉴藏大家项元汴编撰的《历代名瓷图谱》为核心，通过数字化手段对典籍中83件珍稀瓷器进行多维可视化解析。作为首个系统性研究该图谱的数字人文项目，网站构建"溯源-鉴析-探微-品韵"四大维度：溯源篇通过项元汴家族图谱与收藏场景互动，带您穿越回项氏天籁阁的鉴藏现场；鉴析篇以数据可视化呈现瓷器的基本特征与历史背景、时空分布与纹饰工艺、物理属性与设计规律等基础信息脉络；探微篇运用首创的独特性量化模型对项元汴收藏的83件瓷器进行独特性量化分析，从形状、釉色、纹饰、器型和历史五个维度解析瓷器的独特基因，将瓷器的独特性可视化呈现；品韵篇则通过对项元汴个人评价和审美偏好图谱的可视化分析，解码项元汴的个人鉴藏审美偏好和"精鉴藏，通画理"的鉴藏哲学，并试图探索项元汴个人鉴藏偏好（主观）和瓷器独特性量化（客观）之间的关联。在这里，每件瓷器既是独立的美学符号，又是串联起明代文人鉴藏体系的时空坐标，邀您共同探索物质文化与艺术审美的深层对话。
            </span>
            <span className="text-[#000000] text-[0.8vw] text-justify mt-[1.8vw] leading-[1.5vw]">
              This website takes the Atlas of Famous Porcelains of All Ages compiled by Xiang Yuanbian, a great connoisseur of the Ming Dynasty, as the core, and carries out multi-dimensional visual analyses of 83 rare porcelains in the canonical works through digital means. The website builds four dimensions of 'traceability-analysis-analysis-micro-analysis-pin rhyme': the traceability chapter takes you back to Xiang's Heavenly Pavilion's collection site; the analysis chapter presents the basic information of the porcelain with data visualisation; the micro-analysis chapter carries out a quantitative analysis of the uniqueness of the 83 pieces of porcelains in Xiang Yuanbian's collection; and the pin rhyme chapter decodes Xiang's aesthetic preference and philosophy of personal connoisseurship. Here, each piece of porcelain is not only an independent aesthetic symbol, but also a spatial and temporal coordinate linking up the Ming literati's collection system, inviting you to explore the deep dialogue between material culture and artistic aesthetics.
            </span>
          </div>
        </div>
        <img
          src={img_4}
          className={`w-full h-auto absolute bottom-[0vw] left-0 right-0 
            ${img4Visible ? 'opacity-100 clip-path-inset-0' : 'opacity-0 clip-path-inset-bottom'} 
            transition-all duration-3000`} // 过渡动画
        />
      </div>
      {/* 第四部分 */}
      <div className="relative">
        <video
          src={video_1}
          className="w-full h-auto"  // 铺满容器宽度，高度自适应
          autoPlay                  // 自动播放（注意：部分浏览器需要配合 muted）
          loop                      // 循环播放
          muted                     // 静音（避免自动播放被浏览器阻止）
          playsInline               // iOS 设备内联播放（非全屏）
          controls={false}          // 隐藏控制条（根据需求可改为 true 显示）
        />
      </div>
      {/* 第五部分 */}
      <div className="relative" ref={fifthSectionRef}>
        <img src={img_5} alt="Hero background" className="w-full h-auto" />
        <div className="top-[5vw] absolute left-[7%] w-[50%] z-[9999] text-justify leading-[1.5vw]">
          <div className="flex flex-col">
            <span className="text-[#ffffff] text-[1.4vw]">项元汴与嘉兴项氏：风雅世家的鉴藏传奇</span>
            <span className="text-[#ffffff] text-[0.8vw] mt-[1.2vw]">
              嘉兴项氏自南宋南迁扎根浙北，经七代经营，至明嘉靖年间跃为江南文化望族。家族以盐业起家，却以文脉立世，其藏书楼“万卷堂”早于天籁阁闻名吴中。项元汴（1525-1590）字子京，号墨林，明代著名收藏家、鉴赏家，作为家族第六子，未循传统仕途，反以布衣之身成就“明季收藏甲江南”的盛名。他于嘉靖二十九年（1550）创建天籁阁，得名于珍藏的唐代“天籁”铁琴，此阁不仅是藏书之所，更成为汇聚晋唐法书、宋元名画与历代名瓷的艺术圣殿。项氏鉴藏尤重体系化，仅书画便钤盖110余方鉴藏印，形成独特的“墨林密码”。《历代名瓷图谱》正是其收藏观的缩影，83件瓷器从五代秘色瓷到宣德青花，每件皆附工笔彩图与品鉴笔记，开创了中国陶瓷系统著录的先河。这位被董其昌誉为“博物君子”的鉴藏家，以商贾之资构建文人理想国，在晚明商业与文化的激荡中，书写了一部穿梭于风雅与财富之间的物质文化史诗。
            </span>
            <span className="text-[#ffffff] text-[0.8vw]">
              （史实核校依据：李万康《项元汴年谱》、故宫《天籁阁旧藏目录》、项氏墓志铭考释）
            </span>
            <span className="text-[#ffffff] text-[0.8vw] mt-[1.8vw]">
              Xiang Yuanbian and the Jiaxing Xiang Clan: The Legend of Connoisseurship of an Elegant Family
            </span>
            <span className="text-[#ffffff] text-[0.8vw]">
              Xiang Yuanbian (1525-1590) was a famous collector and connoisseur in the Ming Dynasty. As the sixth son of the family, Xiang Yuanbian did not follow the traditional career path, but instead achieved the reputation of ‘Ming Collection of the First South of the Yangtze River’ as a man of ordinary clothes. In 1550, he founded the Heavenly Melody Pavilion, named after the Tang Dynasty ‘Heavenly Melody’ iron qin, which was not only a place for collecting books, but also an art sanctuary gathering Jin and Tang calligraphic books, Song and Yuan paintings, and famous porcelains of the past dynasties. Dong Qichang called the ‘museum gentleman’ collector of connoisseurship, with the capital of merchants and businessmen to build the ideal country of the literati, in the late Ming business and cultural turbulence, writing a shuttle between elegance and wealth of the material culture epic.
            </span>
          </div>
        </div>
        <div className="bottom-[6vw] absolute left-[22%] w-[50%] z-[9999] text-left flex flex-col">
          <span className="text-[#ffffff] text-[2vw] bottom-0">关于项元汴</span>
          <span className="text-[#ffffff] text-[1.5vw]">About Xiang Yuanbian</span>
        </div>
        <img
          src={img_sun}
          className={`w-[20%] h-auto absolute 
            ${isFifthAnimated ? 'bottom-[40%] right-[10vw] opacity-100' : 'bottom-0 right-0 opacity-0'} 
            transition-all duration-3000`}
        />
        <img
          src={img_tree}
          className={`w-[38%] h-auto absolute z-[9999] 
            ${isFifthAnimated ? 'bottom-[-13vw] opacity-100 right-0' : 'bottom-[-20vw] opacity-0 right-[-10vw]'} 
            transition-all duration-3000`}
        />
      </div>
      {/* 第六部分 */}
      <div className="relative" ref={sixthSectionRef}>
        <img src={img_6} alt="Hero background" className="w-full h-auto" />
        <div className="top-[5vw] absolute left-[7%] w-[19%] z-[9999] text-left">
          <div className="flex flex-col">
            <span className="text-[#ffffff] text-[2vw]">收藏品</span>
            <span className="text-[#ffffff] text-[1.8vw]">Collection</span>
            <span className="text-[#ffffff] text-[6vw] mt-[3vw]">{current4600}<span className="text-[#ffffff] text-[1.5vw]"> 余件</span></span>
            <span className="text-[#ffffff] text-[1.5vw] mt-[1vw]">故宫博物院的书画收藏统计</span>
            <span className="text-[#ffffff] text-[1.2vw]">Calligraphy and Painting Collection Statistics of the Palace Museum</span>
          </div>
        </div>
        <div className="top-[14vw] absolute left-[30%] w-[18%] z-[9999] text-left">
          <div className="flex flex-col">
            <span className="text-[#ffffff] text-[6vw]">{current2190}<span className="text-[#ffffff] text-[1.5vw]"> 余件</span></span>
            <span className="text-[#ffffff] text-[1.5vw] mt-[0.6vw]">项元汴个人收藏统计</span>
            <span className="text-[#ffffff] text-[1.2vw]">Personal Collection Statistics of Xiang Yuanbian</span>
          </div>
        </div>
        <div className="top-[5vw] absolute left-[60%] w-[34%] z-[9999] text-left">
          <div className="flex flex-col">
            <span className="text-[#ffffff] text-[2vw]">鉴藏链的形成</span>
            <span className="text-[#ffffff] text-[1.8vw]">Formation of the Art Authentication and Collection Network</span>
            <span className="text-[#ffffff] text-[0.8vw] mt-[1.8vw] text-justify leading-[1.5vw]">艺术品鉴藏是个人或群体比拼眼力、学识和威望的活动，往往受地域、家族、皇权、师承等诸多关系的影响。明代是精品书画鉴藏从内府官藏向民间私人购藏转变的时期。明代中后期，随着大批量的赝品伪作的出现和交易居间人作用的日益凸显，鉴藏风习出现了一些鲜明的时代特色，项元汴为鉴藏中心的江南地区商人群体是这一时期的活跃角色。明代中晚期江南地区商人群体的鉴藏链，以及他们参与的其他商业文化活动。他们购买古玩书画或是为了彰显富贵豪气，或是为了结交文人以投其所好，或是为了提升家族名望。</span>
            <span className="text-[#ffffff] text-[0.8vw] mt-[1.5vw] text-justify leading-[1.5vw]">Art curation and authentication are activities in which individuals or groups compete in vision, knowledge, and prestige, often influenced by regional ties, family lineage, imperial authority, and master-disciple relationships. The Ming dynasty marked a pivotal era in the evolution of premium calligraphy and painting curation, transitioning from imperial collections to private civilian acquisitions. In the mid-to-late Ming period, with the proliferation of forged replicas and the growing role of transactional intermediaries, art collecting developed distinct characteristics of the era. Xiang Yuanbian, a central figure in the Jiangnan region’s commercial art circles, emerged as an active player during this time. The art curation network of Jiangnan’s merchant groups in the mid-to-late Ming period, along with their involvement in broader commercial and cultural activities, reflects the dynamic interplay between art, commerce, and social hierarchies.</span>
          </div>
        </div>
        <img
          src={img_c3}
          className={`w-[30%] h-auto absolute 
            ${isSixthAnimated ? 'bottom-[14%] left-0 opacity-100' : 'bottom-[14%] left-[-10%] opacity-0'} 
            transition-all duration-3000`}
        />
        <img
          src={img_c2}
          className={`w-[20%] h-auto absolute 
            ${isSixthAnimated ? 'bottom-[8%] left-[23%] opacity-100' : 'bottom-[8%] left-[13%] opacity-0'} 
            transition-all duration-3000`}
        />
        <img
          src={img_c1}
          className={`w-[20%] h-auto absolute 
            ${isSixthAnimated ? 'bottom-[13%] left-[38%] opacity-100' : 'bottom-[13%] left-[28%] opacity-0'} 
            transition-all duration-3000`}
        />
      </div>
      {/* 第七部分 */}
      <div className="relative">
        {/* <img src={img_7} alt="Hero background" className="w-full h-auto" /> */}
        <div className='w-full h-auto'>
          <video
            src={video_7}
            className="w-full h-auto"  // 铺满容器宽度，高度自适应
            style={{
              backgroundColor: 'transparent',
              isolation: 'isolate',
              pointerEvents: 'none'
            }}
            autoPlay                  // 自动播放（注意：部分浏览器需要配合 muted）
            loop                      // 循环播放
            muted                     // 静音（避免自动播放被浏览器阻止）
            playsInline               // iOS 设备内联播放（非全屏）
            controls={false}          // 隐藏控制条（根据需求可改为 true 显示）
          />
        </div>
        <div className="top-[8vw] absolute left-[46%] w-[29%] z-[9999] text-left">
          <div className="flex flex-col">
            <span className="text-[#000000] text-[2.3vw]">《历代名瓷图谱》</span>
            <span className="text-[#000000] text-[1.4vw]" style={{ letterSpacing: '0.1vw' }}>Illustrated Catalog of Famous</span>
            <span className="text-[#000000] text-[1.4vw] mt-[-0.2vw]" style={{ letterSpacing: '0.1vw' }}>Porcelain Through the Ages</span>
            <span className="text-[#000000] text-[0.8vw] mt-[1.5vw] text-justify leading-[1.5vw]">项元汴编纂的《历代名瓷图谱》主要收录了宋代到明代的瓷器，作者生平所见所藏朱元明渚窑名瓷83器，并一一为之图解，图施彩绘，区分类聚，勒成十册。成书于明万历十五年（1587），《历代名瓷图谱》是鉴藏大家项元汴晚年系统整理毕生所藏的陶瓷著录，承载了中国几千年的瓷器文化与艺术智慧。项氏以“图谱合一”的创新体例，每器配工笔彩绘并附鉴评，开创中国陶瓷系统研究的先河（故宫博物院《天籁阁旧藏考》）。其83件瓷器涵盖越窑秘色瓷、宋代五大名窑、元青花等，兼具历史断代与工艺独特性。项元汴更以“三鉴论”（形制、釉色、流传）构建鉴藏体系，钤盖110余方鉴藏印，使每件器物成为串联官窑技艺、文人审美与商业流通的时空坐标。这部尘封四百年的图谱，不仅是晚明物质文化的巅峰注脚，更在数字时代重现“一器一宇宙”的文明对话。
            </span>
            <span className="text-[#000000] text-[0.8vw] mt-[1vw] text-justify leading-[1.5vw]">Xiang Yuanbian compiled the 'famous porcelain atlas of successive dynasties' mainly included the Song Dynasty to the Ming Dynasty porcelain, the author's life saw the collection of Zhu Yuanmingzhu kiln famous porcelain 83 ware, and one by one for the illustration, the map is painted, differentiated class gathering, le into ten books. Became a book in Ming Wanli fifteen years (1587), carrying thousands of years of China's porcelain culture and artistic wisdom. Xiang's innovative style of 'chart and spectrum in one', with brushstrokes and coloured paintings on each vessel and commentary, pioneered the systematic study of Chinese ceramics (The Old Collection of Heavenly Pavilion of the Palace Museum). The 83 pieces of porcelain include Yue kiln secret colour porcelain, five famous kilns of the Song dynasty, Yuan blue and white, etc., combining historical discontinuity and craftsmanship uniqueness.
            </span>
          </div>
        </div>
      </div>
      {/* 第八部分 */}
      <div className="relative" id="molin-section" style={{ transform: 'none' }}>
        <img src={img_8} alt="Hero background" className="w-full h-auto" />
        <div className="top-[18vw] w-auto absolute left-[52%] transform -translate-x-1/2">
          <div className="flex flex-row items-left gap-[1.5vw]">
            <span className="text-[3.5vw] vertical-text-ml">墨林迷踪</span>
            <span className="text-[1.5vw] rotate-90 " style={{
              marginTop: '5vw',
            }}>Inkwood Odyssey</span>
          </div>
        </div>
        <div className="top-[16vw] w-auto absolute left-[62%] transform -translate-x-1/2">
          <div className="flex flex-row items-left gap-[1.5vw]">
            <span className="text-[2vw] vertical-text-ml">—项元汴的鉴藏故事</span>
            <span className="text-[1.2vw] rotate-90 ml-[1vw]" style={{
              marginTop: '3vw',
            }}>Story of Yuanbian Xiang's collection</span>
          </div>
        </div>
        <div className="top-[3.5vw] absolute left-[8%] w-[85%] z-[9999] text-center text-[0.7vw] leading-[1.1vw] text-[#ffffff] " style={{ letterSpacing: '0.1vw' }}>
          <div className="flex flex-col">
            <span className="">欢迎步入明万历年的嘉兴府城。这座运河交织的繁华市镇，正以数字笔墨重现项元汴的鉴藏宇宙：漕船林立的码头飘荡着南北商贾的乡音，街肆鳞次栉比的古董铺半掩门扉，天籁阁的飞檐下堆积着未启封的木匣。您将在此亲历五种收藏际遇——与行商周旋真伪，同雅士品鉴赠礼，于当铺裁决典当品的归宿，在集市沙海淘金，更可踏入藏家宅院解码艺术社交的暗语。</span>
            <span className="text-[0.6vw]">Welcome to Jiaxing Prefecture in the Ming Dynasty. This bustling town intertwined with canals is digitally recreating Xiang Yuanbian's universe of collectors: the wharves lined with canals are filled with the native voices of merchants from the north and the south, the antique shops lined up in the streets are half-closed, and under the flying eaves of the Celestial Pavilion there are piles of unopened wooden boxes. Here you will experience five kinds of collecting encounters - dealing with dealers on authenticity, appraising gifts with elegant people, adjudicating the fate of pawned goods in pawnshops, panning for gold in bazaars, and even stepping into a collector's house to decode the secret language of artistic socialising.</span>
            <span className="mt-[1vw]">点击开始，带您穿越回明万历年的江南鉴藏江湖，自由探索吧……</span>
            <span className="">Click to start, take you back to the Ming Wanli year Jiangnan Tibetan jianghu, free to explore it ......</span>
          </div>
        </div>
        <div className="bottom-[5vw] absolute left-[5%] w-[33%] z-[9999] text-left">
          <div className="flex flex-col">
            <span className="text-[#ffffff] text-[0.7vw] leading-[1.3vw] text-justify">根据史实与典故记载，我们重构还原了项元汴及其家族进行鉴藏活动的五大场景的游戏式沉浸体验。我们将带您穿越回万历年的嘉兴府城，在天籁阁的飞檐下，解码一部尘封四百年的陶瓷史诗。天籁阁的虚拟场景以空间叙事还原鉴藏现场：从漕船码头的商贾交锋，到古董铺的纹饰辨析，每一处细节皆暗含明代商业与文化的激荡。我们采用知识图谱技术关联人物、器物、文献，构建可视化的鉴藏关系网络，让历史场景成为可交互的“活档案”。
              每一处建筑皆是时光入口：点击斑驳的窗棂，或许触发明代最大规模的书画交割；驻足喧闹的街角，可能偶遇改变艺术史流向的密谈。当83件瓷器的灵光在数据中苏醒，这座虚实交织的城池，正等待您用洞察力编织出项元汴“钤印为史，藏器成谱”的文明图景。</span>
            <span className="text-[#ffffff] text-[0.7vw] leading-[1.3vw] text-justify">Based on historical facts and allusions, we have reconstructed and restored the game-like immersive experience of the five major scenes of Xiang Yuanbian and his family's collection activities. We will take you back to the Jiaxing capital in the Wanli period, and decode a 400-year-old ceramic epic under the flying eaves of the Heavenly Pavilion. </span>
          </div>
        </div>
        <div className="bottom-[6vw] absolute left-[63%] w-[33%] z-[9999] text-left">
          <div className="flex flex-col">
            <span className="text-[#ffffff] text-[0.7vw] leading-[1.3vw] text-justify">The virtual scene of Tianlai Pavilion is a spatial narrative that restores the scene of authentication: from the exchange of businessmen and merchants at the dock of a ship, to the analysis of decorations at an antique shop, every detail implies the turbulence of commerce and culture in the Ming Dynasty. We use knowledge mapping technology to link people, artefacts and documents, and build a visual network of relationship between the collection and the people, so that the historical scene becomes an interactive 'living archive'. Every building is a portal to time: clicking on a mottled window pane may trigger the largest delivery of paintings and calligraphy in the Ming Dynasty; stopping at a noisy street corner may lead to a secret conversation that changes the flow of art history. When the aura of 83 pieces of porcelain wakes up in the data, this city, where reality and reality are intertwined, is waiting for you to use your insight to weave the civilisation of Xiang Yuanbian's 'Inscription for History, Collection of Weapons for Genealogy'.</span>
          </div>
        </div>
        <div
          className="absolute w-auto bottom-[8vw] left-[50%] transform -translate-x-1/2 z-[9999] transparent-rounded-button flex flex-col items-center text-center"
          onClick={() => navigate('/explorationmolin')}
        >
          <span className='text-[1.5vw]'>开始探索</span>
          <span className='text-[1.2vw] mt-[-0.2vw]'>START</span>
        </div>
      </div>
      {/* 第九部分 */}
      <div className="relative">
        <img src={img_9} alt="Hero background" className="w-full h-auto" />
        <div className="top-[4vw] absolute left-[10%] w-[80%] z-[9999] text-center">
          <div className="flex flex-col">
            <span className="text-[#ffffff] text-[1.8vw]">《历代名瓷图谱》多维可视化解析</span>
            <span className="text-[#ffffff] text-[1.4vw] mt-[0.2vw]" style={{ letterSpacing: '0.1vw' }}>Multi-dimensional Visualisation Analysis of "The Atlas of Famous Porcelains of All Ages"</span>
          </div>
        </div>
        {/* 卡片区域 */}
        <div>
          {/* 第一张卡片 */}
          <div
            className={`absolute bottom-[10%] h-[70%]  w-[30%] transition-transform duration-300 ease-in-out hover:scale-105
                      ${activeCard === 0 ? 'left-[3%] w-[50%]' : ''}
                      ${activeCard === 1 ? 'left-[-11%] w-[25%]' : ''}
                      ${activeCard === 2 ? 'left-[-17%] w-[25%]' : ''}`}  /* 示例索引0的卡片位置 */
            onClick={() => setActiveCard(0)} >
            <div className="top-[1vw] absolute left-[18%] w-[60%] z-[9999] text-center">
              <div className="flex flex-col">
                <span className={`text-[#ffffff]  ${activeCard === 0 ? 'text-[2vw]' : 'text-[1.4vw]'}`}>鉴析—瓷器基本信息可视化</span>
                <span className={`text-[#ffffff]  ${activeCard === 0 ? 'text-[1.2vw]' : 'text-[1vw]'}`}>Appreciation</span>
                <span className={`text-[#ffffff]  ${activeCard === 0 ? 'text-[1.2vw]' : 'text-[1vw]'}`}>Visualisation of basic information on porcelain</span>
              </div>
            </div>
            <div className={` rounded-[36px] ${activeCard === 0 ? 'mt-[10vw]' : 'mt-[15vw]'}`}>
              <video
                src={video_jx}
                className="w-full h-auto rounded-[36px]"  // 铺满容器宽度，高度自适应
                autoPlay                  // 自动播放（注意：部分浏览器需要配合 muted）
                loop                      // 循环播放
                muted                     // 静音（避免自动播放被浏览器阻止）
                playsInline               // iOS 设备内联播放（非全屏）
                controls={false}          // 隐藏控制条（根据需求可改为 true 显示）
              />
            </div>
          </div>
          {/* 第二张卡片 */}
          <div
            className={` absolute bottom-[10%] h-[70%]  w-[30%] transition-transform duration-300 ease-in-out hover:scale-105
                      ${activeCard === 0 ? 'left-[55%] w-[25%]' : ''}
                      ${activeCard === 1 ? 'left-[24%] w-[50%]' : ''}
                      ${activeCard === 2 ? 'left-[15%] w-[25%]' : ''}`}
            onClick={() => setActiveCard(1)} >
            <div className="top-[1vw] absolute left-[18%] w-[60%] z-[9999] text-center">
              <div className="flex flex-col">
                <span className={`text-[#ffffff]  ${activeCard === 1 ? 'text-[2vw]' : 'text-[1.4vw]'}`}>探微—瓷器独特性量化分析</span>
                <span className={`text-[#ffffff]  ${activeCard === 1 ? 'text-[1.2vw]' : 'text-[1vw]'}`}>Exploration</span>
                <span className={`text-[#ffffff]  ${activeCard === 1 ? 'text-[1.2vw]' : 'text-[1vw]'}`}>Quantitative Analysis of Porcelain Uniqueness</span>
              </div>
            </div>
            <div className={` rounded-[36px] ${activeCard === 1 ? 'mt-[10vw]' : 'mt-[15vw]'}`}>
              <video
                src={video_tw}
                className="w-full h-auto rounded-[36px]"  // 铺满容器宽度，高度自适应
                autoPlay                  // 自动播放（注意：部分浏览器需要配合 muted）
                loop                      // 循环播放
                muted                     // 静音（避免自动播放被浏览器阻止）
                playsInline               // iOS 设备内联播放（非全屏）
                controls={false}          // 隐藏控制条（根据需求可改为 true 显示）
              />
            </div>
          </div>
          {/* 第三张卡片 */}
          <div
            className={` absolute bottom-[10%] h-[70%] w-[30%] transition-transform duration-300 ease-in-out hover:scale-105
                        ${activeCard === 0 ? 'left-[87%] w-[25%]' : ''}
                        ${activeCard === 1 ? 'left-[80%] w-[25%]' : ''}
                        ${activeCard === 2 ? 'left-[47%] w-[50%]' : ''}`}  /* 示例索引0的卡片位置 */
            onClick={() => setActiveCard(2)} >
            <div className="top-[1vw] absolute left-[18%] w-[60%] z-[9999] text-center">
              <div className="flex flex-col">
                <span className={`text-[#ffffff]  ${activeCard === 2 ? 'text-[2vw]' : 'text-[1.4vw]'}`}>品韵—项元汴个人审美偏好</span>
                <span className={`text-[#ffffff]  ${activeCard === 2 ? 'text-[1.2vw]' : 'text-[1vw]'}`}>Rhyme Tasting</span>
                <span className={`text-[#ffffff]  ${activeCard === 2 ? 'text-[1.2vw]' : 'text-[1vw]'}`}>Xiang YuanBian's Personal Aesthetic Preferences</span>
              </div>
            </div>
            <div className={` rounded-[36px] ${activeCard === 2 ? 'mt-[10vw]' : 'mt-[15vw]'}`}>
              <video
                src={video_py}
                className="w-full h-auto rounded-[36px]"  // 铺满容器宽度，高度自适应
                autoPlay                  // 自动播放（注意：部分浏览器需要配合 muted）
                loop                      // 循环播放
                muted                     // 静音（避免自动播放被浏览器阻止）
                playsInline               // iOS 设备内联播放（非全屏）
                controls={false}          // 隐藏控制条（根据需求可改为 true 显示）
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}